/**
 * Parses option value strings from measurement presets e.g "Width: 120, Length: 100, Drop: 50")
 * Checking presets vs custom inputs.
 */
(function () {
  'use strict';

  const parseMeasurementPresetString = (str) => {
    if (!str || typeof str !== 'string') return null;

    let parsed = { width: null, length: null, drop: null };
    let unassigned = [];

    str.split(',').forEach(function (segment) {
      let matchedSegment = segment.trim().match(/^([^:]+):\s*(.+)$/);
      if (!matchedSegment) return;

      let keyRaw = matchedSegment[1].replace(/\([^)]*\)/g, '').trim().toLowerCase();
      let num = parseFloat(String(matchedSegment[2]).trim().replace(/[^\d.-]/g, ''));
      if (isNaN(num)) return;

      if (keyRaw.indexOf('drop') !== -1) {
        parsed.drop = num;
      } else if (keyRaw.indexOf('length') !== -1) {
        parsed.length = num;
      } else if (keyRaw.indexOf('width') !== -1 || keyRaw.indexOf('rail') !== -1) {
        parsed.width = num;
      } else {
        unassigned.push(num);
      }
    });

    let initialIndex = 0;

    if (parsed.width == null && unassigned[initialIndex] !== undefined) parsed.width = unassigned[initialIndex++];
    if (parsed.length == null && unassigned[initialIndex] !== undefined) parsed.length = unassigned[initialIndex++];
    if (parsed.drop == null && unassigned[initialIndex] !== undefined) parsed.drop = unassigned[initialIndex++];

    if (parsed.width == null && parsed.length == null && parsed.drop == null) return null;

    return parsed;
  }

  window.parseMeasurementPresetString = parseMeasurementPresetString;

  document.addEventListener('measurementPresetSelected', function (event) {
    const raw = event.detail && event.detail.measurementPreset;
    const parsed = parseMeasurementPresetString(raw);

    window.__measurementPresetParsed = parsed;
    window.__measurementPresetActive = !!(
      parsed &&
      (parsed.width != null || parsed.length != null || parsed.drop != null)
    );
  });

  document.addEventListener('measurementPresetCleared', function () {
    window.__measurementPresetParsed = null;
    window.__measurementPresetActive = false;
  });
})();
